export default __webpack_public_path__ + "static/media/allAround.09bdb597.mp3";